import type { CoverSheetConfigCard } from '../../types';
import { coAgentLicenseNumberCharacterValidation } from '../validation';

export const agentCard = {
  id: 'agent',
  entity: 'contacts',
  entityType: 'agent',
  innerTitle: 'Agent',
  outerTitle: 'Agents',
  legend: '* indicates a required field',
  isAddable: true,
  addableTitle: 'Co Agent',
  maxAddable: 4,
  addText: 'Co Agent',
  addByDefault: true,
  isCollapsible: true,
  syncsWithGoogleContacts: true,
  action: {
    name: 'sync',
    provider: 'transactionOwner',
    indices: [0],
    props: [
      {
        from: 'firstName',
        to: 'contacts.agent.x.firstName',
      },
      {
        from: 'lastName',
        to: 'contacts.agent.x.lastName',
      },
      {
        from: 'email',
        to: 'contacts.agent.x.email',
      },
      {
        from: 'cellPhone',
        to: 'contacts.agent.x.cellPhone',
      },
      {
        from: 'licenseNumber',
        to: 'contacts.agent.x.licenseNumber',
      },
      {
        from: 'avatar',
        to: 'contacts.agent.x.avatar',
        label: 'Profile Avatar',
      },
      {
        from: 'companyName',
        to: 'contacts.agent.x.brokerage.companyName',
        label: 'Brokerage Company',
      },
      {
        from: 'brokerageLicenseNumber',
        to: 'contacts.agent.x.brokerage.licenseNumber',
        label: 'Brokerage License #',
      },
      {
        from: 'brokerageOfficeEmail',
        to: 'contacts.agent.x.brokerage.officeEmail',
      },
      {
        from: 'brokerageCellPhone',
        to: 'contacts.agent.x.brokerage.cellPhone',
      },
      {
        from: 'brokerageEmail',
        to: 'contacts.agent.x.brokerage.email',
      },
      {
        from: 'brokerageMlsCode',
        to: 'contacts.agent.x.brokerage.mlsCode',
      },
      {
        from: 'broker.firstName',
        to: 'contacts.agent.x.broker.firstName',
      },
      {
        from: 'broker.lastName',
        to: 'contacts.agent.x.broker.lastName',
      },
      {
        from: 'broker.licenseNumber',
        to: 'contacts.agent.x.broker.licenseNumber',
      },
      {
        from: 'broker.cellPhone',
        to: 'contacts.agent.x.broker.cellPhone',
      },
      {
        from: 'broker.email',
        to: 'contacts.agent.x.broker.email',
      },
      {
        from: 'supervisingBroker.firstName',
        to: 'contacts.agent.x.supervisingBroker.firstName',
      },
      {
        from: 'supervisingBroker.lastName',
        to: 'contacts.agent.x.supervisingBroker.lastName',
      },
      {
        from: 'supervisingBroker.licenseNumber',
        to: 'contacts.agent.x.supervisingBroker.licenseNumber',
      },
      {
        from: 'supervisingBroker.cellPhone',
        to: 'contacts.agent.x.supervisingBroker.cellPhone',
      },
      {
        from: 'supervisingBroker.email',
        to: 'contacts.agent.x.supervisingBroker.email',
      },
      {
        from: 'officeManager.firstName',
        to: 'contacts.agent.x.officeManager.firstName',
      },
      {
        from: 'officeManager.lastName',
        to: 'contacts.agent.x.officeManager.lastName',
      },
      {
        from: 'officeManager.licenseNumber',
        to: 'contacts.agent.x.officeManager.licenseNumber',
      },
      {
        from: 'officeManager.cellPhone',
        to: 'contacts.agent.x.officeManager.cellPhone',
      },
      {
        from: 'officeManager.email',
        to: 'contacts.agent.x.officeManager.email',
      },
      {
        from: 'street1',
        to: 'contacts.agent.x.brokerage.street1',
      },
      {
        from: 'street2',
        to: 'contacts.agent.x.brokerage.street2',
      },
      {
        from: 'city',
        to: 'contacts.agent.x.brokerage.city',
      },
      {
        from: 'state',
        to: 'contacts.agent.x.brokerage.state',
      },
      {
        from: 'zipCode',
        to: 'contacts.agent.x.brokerage.zip',
      },
      {
        from: 'agentCommission',
        to: 'contacts.agent.x.commission',
      },
      {
        from: 'sellingAgentCommission',
        to: 'contacts.agent.x.sellingCommission',
      },
    ],
  },
  displayFields: [
    {
      name: 'contacts.agent.x.firstName',
      type: 'name',
    },
    {
      name: 'contacts.agent.x.lastName',
      type: 'name',
    },
    {
      name: 'contacts.agent.x.licenseNumber',
      type: 'default',
    },
    {
      name: 'contacts.agent.x.email',
      type: 'email',
    },
    {
      name: 'contacts.agent.x.cellPhone',
      type: 'phone',
    },
    {
      name: 'contacts.agent.x.brokerage.companyName',
      type: 'default',
    },
    {
      name: 'contacts.agent.x.brokerage.licenseNumber',
      type: 'default',
    },
  ],
  collapsedName: ['contacts.agent.x.firstName', 'contacts.agent.x.lastName'],
  disallowRemoveForIndex: [0],
  layout: [
    [
      {
        name: 'contacts.agent.x.submitAs',
        size: 100,
      },
    ],
    [
      {
        name: 'contacts.agent.x.firstName',
        size: 50,
      },
      {
        name: 'contacts.agent.x.lastName',
        size: 50,
      },
    ],
    [
      {
        name: 'contacts.agent.x.email',
        size: 50,
      },
      {
        name: 'contacts.agent.x.cellPhone',
        size: 50,
      },
    ],
    [
      {
        name: 'contacts.agent.x.licenseNumber',
        size: 100,
      },
    ],
    [
      {
        name: 'contacts.agent.x.brokerage.companyName',
        size: 50,
      },
      {
        name: 'contacts.agent.x.brokerage.licenseNumber',
        size: 50,
      },
    ],
    [
      {
        name: 'contacts.agent.x.brokerage.street1',
        size: 75,
      },
      {
        name: 'contacts.agent.x.brokerage.street2',
        size: 25,
      },
    ],
    [
      {
        name: 'contacts.agent.x.brokerage.city',
        size: 50,
      },
      {
        name: 'contacts.agent.x.brokerage.state',
        size: 25,
        mobileSize: 50,
      },
      {
        name: 'contacts.agent.x.brokerage.zip',
        size: 25,
        mobileSize: 50,
      },
    ],
  ],
  fields: {
    firstName: {
      name: 'contacts.agent.x.firstName',
      entity: 'contacts',
      entityType: 'agent',
      type: 'autofill',
      label: 'First Name',
      placeholderText: '',
      disabledForIndex: 0,
      action: {
        name: 'autofill',
        provider: 'contactSuggestion',
        label: {
          primary: 'fullName',
          secondary: 'email',
        },
        props: [
          {
            from: 'googleContactId',
            to: 'contacts.agent.x.googleContactId',
          },
          {
            from: 'contactSource',
            to: 'contacts.agent.x.contactSource',
          },
          {
            from: 'teamId',
            to: 'contacts.agent.x.teamId',
          },
          {
            from: 'teamName',
            to: 'contacts.agent.x.teamName',
          },
          {
            from: 'firstName',
            to: 'contacts.agent.x.firstName',
          },
          {
            from: 'lastName',
            to: 'contacts.agent.x.lastName',
          },
          {
            from: 'email',
            to: 'contacts.agent.x.email',
          },
          {
            from: 'cellPhone',
            to: 'contacts.agent.x.cellPhone',
          },
          {
            from: 'licenseNumber',
            to: 'contacts.agent.x.licenseNumber',
          },
          {
            from: 'avatar',
            to: 'contacts.agent.x.avatar',
          },
          {
            from: 'brokerage.companyName',
            to: 'contacts.agent.x.brokerage.companyName',
          },
          {
            from: 'brokerage.licenseNumber',
            to: 'contacts.agent.x.brokerage.licenseNumber',
          },
          {
            from: 'brokerage.street1',
            to: 'contacts.agent.x.brokerage.street1',
          },
          {
            from: 'brokerage.street2',
            to: 'contacts.agent.x.brokerage.street2',
          },
          {
            from: 'brokerage.city',
            to: 'contacts.agent.x.brokerage.city',
          },
          {
            from: 'brokerage.state',
            to: 'contacts.agent.x.brokerage.state',
          },
          {
            from: 'brokerage.zip',
            to: 'contacts.agent.x.brokerage.zip',
          },
          {
            from: 'userId',
            to: 'contacts.agent.x.userId',
          },
        ],
      },
      validation: [
        {
          type: 'required',
          message: 'Required',
        },
      ],
    },
    avatar: {
      name: 'contacts.agent.x.avatar',
      entity: 'contacts',
      entityType: 'agent',
      type: 'hidden',
      label: 'Avatar',
    },
    lastName: {
      name: 'contacts.agent.x.lastName',
      entity: 'contacts',
      entityType: 'agent',
      type: 'text',
      label: 'Last Name',
      placeholderText: '',
      disabledForIndex: 0,
      validation: [
        {
          type: 'required',
          message: 'Required',
        },
      ],
    },
    email: {
      name: 'contacts.agent.x.email',
      entity: 'contacts',
      entityType: 'agent',
      type: 'text',
      label: 'Email',
      placeholderText: '',
      disabledForIndex: 0,
      validation: [
        {
          type: 'required',
          message: 'Required',
        },
        {
          type: 'email',
          message: 'Invalid email',
        },
      ],
    },
    cellPhone: {
      name: 'contacts.agent.x.cellPhone',
      entity: 'contacts',
      entityType: 'agent',
      type: 'phone',
      label: 'Cell Phone',
      placeholderText: '',
      disabledForIndex: 0,
      validation: [
        {
          type: 'phone',
          message: 'Invalid phone number',
        },
      ],
    },
    licenseNumber: {
      name: 'contacts.agent.x.licenseNumber',
      entity: 'contacts',
      entityType: 'agent',
      type: 'text',
      label: 'Agent License Number',
      placeholderText: '',
      disabledForIndex: 0,
      validation: [
        {
          type: 'required',
          message: 'Required',
          appliesToIndex: [0],
        },
        coAgentLicenseNumberCharacterValidation,
      ],
    },
    brokerageCompanyName: {
      name: 'contacts.agent.x.brokerage.companyName',
      entity: 'contacts',
      entityType: 'agent',
      type: 'text',
      label: 'Brokerage Name',
      placeholderText: '',
      disabledForIndex: 0,
      validation: [
        {
          type: 'required',
          message: 'Required',
          appliesToIndex: [0],
        },
      ],
    },
    brokerageLicenseNumber: {
      name: 'contacts.agent.x.brokerage.licenseNumber',
      entity: 'contacts',
      entityType: 'agent',
      type: 'text',
      label: 'Brokerage License Number',
      placeholderText: '',
      disabledForIndex: 0,
      validation: [
        {
          type: 'required',
          message: 'Required',
          appliesToIndex: [0],
        },
        coAgentLicenseNumberCharacterValidation,
      ],
    },
    brokerageStreet1: {
      name: 'contacts.agent.x.brokerage.street1',
      entity: 'contacts',
      entityType: 'agent',
      type: 'autofill',
      label: 'Street',
      placeholderText: '',
      disabledForIndex: 0,
      action: {
        name: 'autofill',
        provider: 'googlePlacesSearch',
        label: {
          primary: 'label.primary',
          secondary: 'label.secondary',
        },
        props: [
          {
            from: 'street1',
            to: 'contacts.agent.x.brokerage.street1',
          },
          {
            from: 'street2',
            to: 'contacts.agent.x.brokerage.street2',
          },
          {
            from: 'city',
            to: 'contacts.agent.x.brokerage.city',
          },
          {
            from: 'state',
            to: 'contacts.agent.x.brokerage.state',
          },
          {
            from: 'county',
            to: 'contacts.agent.x.brokerage.county',
          },
          {
            from: 'zip',
            to: 'contacts.agent.x.brokerage.zip',
          },
        ],
      },
    },
    brokerageStreet2: {
      name: 'contacts.agent.x.brokerage.street2',
      entity: 'contacts',
      entityType: 'agent',
      type: 'text',
      label: 'Apt/Unit/Suite Number',
      placeholderText: '',
      disabledForIndex: 0,
    },
    brokerageCity: {
      name: 'contacts.agent.x.brokerage.city',
      entity: 'contacts',
      entityType: 'agent',
      type: 'text',
      label: 'City',
      placeholderText: '',
      disabledForIndex: 0,
    },
    brokerageState: {
      name: 'contacts.agent.x.brokerage.state',
      entity: 'contacts',
      entityType: 'agent',
      type: 'state',
      label: 'State',
      placeholderText: '',
      disabledForIndex: 0,
    },
    brokerageZip: {
      name: 'contacts.agent.x.brokerage.zip',
      entity: 'contacts',
      entityType: 'agent',
      type: 'zip',
      label: 'Zip Code',
      placeholderText: '',
      disabledForIndex: 0,
    },
    submitAs: {
      name: 'contacts.agent.x.submitAs',
      type: 'changeTransactionOwner',
      label: 'Select Agent',
      placeholderText: '',
      visibleForIndex: 0,
      validation: [
        {
          type: 'required',
          message: 'Required',
        },
      ],
      action: {
        name: 'mapFromFields',
        props: [
          {
            from: 'id',
            to: 'contacts.agent.x.userId',
          },
          {
            from: 'teamId',
            to: 'contacts.agent.x.teamId',
          },
          {
            from: 'teamName',
            to: 'contacts.agent.x.teamName',
          },
          {
            from: 'firstName',
            to: 'contacts.agent.x.firstName',
          },
          {
            from: 'lastName',
            to: 'contacts.agent.x.lastName',
          },
          {
            from: 'email',
            to: 'contacts.agent.x.email',
          },
          {
            from: 'cellPhone',
            to: 'contacts.agent.x.cellPhone',
          },
          {
            from: 'licenseNumber',
            to: 'contacts.agent.x.licenseNumber',
          },
          {
            from: 'avatar',
            to: 'contacts.agent.x.avatar',
          },
          {
            from: 'companyName',
            to: 'contacts.agent.x.brokerage.companyName',
          },
          {
            from: 'brokerageLicenseNumber',
            to: 'contacts.agent.x.brokerage.licenseNumber',
          },
          {
            from: 'brokerageOfficeEmail',
            to: 'contacts.agent.x.brokerage.officeEmail',
          },
          {
            from: 'brokerageCellPhone',
            to: 'contacts.agent.x.brokerage.cellPhone',
          },
          {
            from: 'brokerageEmail',
            to: 'contacts.agent.x.brokerage.email',
          },
          {
            from: 'brokerageMlsCode',
            to: 'contacts.agent.x.brokerage.mlsCode',
          },
          {
            from: 'broker.firstName',
            to: 'contacts.agent.x.broker.firstName',
          },
          {
            from: 'broker.lastName',
            to: 'contacts.agent.x.broker.lastName',
          },
          {
            from: 'broker.licenseNumber',
            to: 'contacts.agent.x.broker.licenseNumber',
          },
          {
            from: 'broker.cellPhone',
            to: 'contacts.agent.x.broker.cellPhone',
          },
          {
            from: 'broker.email',
            to: 'contacts.agent.x.broker.email',
          },
          {
            from: 'supervisingBroker.firstName',
            to: 'contacts.agent.x.supervisingBroker.firstName',
          },
          {
            from: 'supervisingBroker.lastName',
            to: 'contacts.agent.x.supervisingBroker.lastName',
          },
          {
            from: 'supervisingBroker.licenseNumber',
            to: 'contacts.agent.x.supervisingBroker.licenseNumber',
          },
          {
            from: 'supervisingBroker.cellPhone',
            to: 'contacts.agent.x.supervisingBroker.cellPhone',
          },
          {
            from: 'supervisingBroker.email',
            to: 'contacts.agent.x.supervisingBroker.email',
          },
          {
            from: 'officeManager.firstName',
            to: 'contacts.agent.x.officeManager.firstName',
          },
          {
            from: 'officeManager.lastName',
            to: 'contacts.agent.x.officeManager.lastName',
          },
          {
            from: 'officeManager.licenseNumber',
            to: 'contacts.agent.x.officeManager.licenseNumber',
          },
          {
            from: 'officeManager.cellPhone',
            to: 'contacts.agent.x.officeManager.cellPhone',
          },
          {
            from: 'officeManager.email',
            to: 'contacts.agent.x.officeManager.email',
          },
          {
            from: 'street1',
            to: 'contacts.agent.x.brokerage.street1',
          },
          {
            from: 'street2',
            to: 'contacts.agent.x.brokerage.street2',
          },
          {
            from: 'city',
            to: 'contacts.agent.x.brokerage.city',
          },
          {
            from: 'state',
            to: 'contacts.agent.x.brokerage.state',
          },
          {
            from: 'zipCode',
            to: 'contacts.agent.x.brokerage.zip',
          },
          {
            from: 'agentCommission',
            to: 'contacts.agent.x.commission',
          },
          {
            from: 'sellingAgentCommission',
            to: 'contacts.agent.x.sellingCommission',
          },
        ],
      },
    },
    userId: {
      name: 'contacts.agent.x.userId',
      label: 'User Id',
      type: 'hidden',
      entity: 'contacts',
      entityType: 'agent',
    },
    brokerageOfficeEmail: {
      name: 'contacts.agent.x.brokerage.officeEmail',
      type: 'hidden',
      label: 'Brokerage Office Email',
      entity: 'contacts',
      entityType: 'agent',
    },
    brokerageCellPhone: {
      name: 'contacts.agent.x.brokerage.cellPhone',
      type: 'hidden',
      label: 'Brokerage Phone',
      entity: 'contacts',
      entityType: 'agent',
    },
    brokerageEmail: {
      name: 'contacts.agent.x.brokerage.email',
      type: 'hidden',
      label: 'Brokerage Email',
      entity: 'contacts',
      entityType: 'agent',
    },
    brokerageMlsCode: {
      name: 'contacts.agent.x.brokerage.mlsCode',
      type: 'hidden',
      label: 'Brokerage MLS Code',
      entity: 'contacts',
      entityType: 'agent',
    },
    brokerageMlsId: {
      name: 'contacts.agent.x.brokerage.mlsId',
      type: 'hidden',
      label: 'Brokerage MLS Id',
      entity: 'contacts',
      entityType: 'agent',
    },
    brokerFirstName: {
      name: 'contacts.agent.x.broker.firstName',
      type: 'hidden',
      label: 'Broker First Name',
      entity: 'contacts',
      entityType: 'agent',
    },
    brokerLastName: {
      name: 'contacts.agent.x.broker.lastName',
      type: 'hidden',
      label: 'Broker Last Name',
      entity: 'contacts',
      entityType: 'agent',
    },
    brokerLicenseNumber: {
      name: 'contacts.agent.x.broker.licenseNumber',
      type: 'hidden',
      label: 'Broker License #',
      entity: 'contacts',
      entityType: 'agent',
    },
    brokerCellPhone: {
      name: 'contacts.agent.x.broker.cellPhone',
      type: 'hidden',
      label: 'Broker Cell Phone',
      entity: 'contacts',
      entityType: 'agent',
    },
    brokerEmail: {
      name: 'contacts.agent.x.broker.email',
      type: 'hidden',
      label: 'Broker Email',
      entity: 'contacts',
      entityType: 'agent',
    },
    supervisingBrokerFirstName: {
      name: 'contacts.agent.x.supervisingBroker.firstName',
      type: 'hidden',
      label: 'Supervising Broker First Name',
      entity: 'contacts',
      entityType: 'agent',
    },
    supervisingBrokerLastName: {
      name: 'contacts.agent.x.supervisingBroker.lastName',
      type: 'hidden',
      label: 'Supervising Broker Last Name',
      entity: 'contacts',
      entityType: 'agent',
    },
    supervisingBrokerLicenseNumber: {
      name: 'contacts.agent.x.supervisingBroker.licenseNumber',
      type: 'hidden',
      label: 'Supervising Broker License #',
      entity: 'contacts',
      entityType: 'agent',
    },
    supervisingBrokerCellPhone: {
      name: 'contacts.agent.x.supervisingBroker.cellPhone',
      type: 'hidden',
      label: 'Supervising Broker Cell Phone',
      entity: 'contacts',
      entityType: 'agent',
    },
    supervisingBrokerEmail: {
      name: 'contacts.agent.x.supervisingBroker.email',
      type: 'hidden',
      label: 'Supervising Broker Email',
      entity: 'contacts',
      entityType: 'agent',
    },
    officeManagerFirstName: {
      name: 'contacts.agent.x.officeManager.firstName',
      type: 'hidden',
      label: 'Office Manager First Name',
      entity: 'contacts',
      entityType: 'agent',
    },
    officeManagerLastName: {
      name: 'contacts.agent.x.officeManager.lastName',
      type: 'hidden',
      label: 'Office Manager Last Name',
      entity: 'contacts',
      entityType: 'agent',
    },
    officeManagerLicenseNumber: {
      name: 'contacts.agent.x.officeManager.licenseNumber',
      type: 'hidden',
      label: 'Office Manager License #',
      entity: 'contacts',
      entityType: 'agent',
    },
    officeManagerCellPhone: {
      name: 'contacts.agent.x.officeManager.cellPhone',
      type: 'hidden',
      label: 'Office Manager Cell Phone',
      entity: 'contacts',
      entityType: 'agent',
    },
    officeManagerEmail: {
      name: 'contacts.agent.x.officeManager.email',
      type: 'hidden',
      label: 'Office Manager Email',
      entity: 'contacts',
      entityType: 'agent',
    },
    agentCommission: {
      name: 'contacts.agent.x.commission',
      type: 'hidden',
      label: 'Agent Commission %',
      entity: 'contacts',
      entityType: 'agent',
    },
    sellingAgentCommission: {
      name: 'contacts.agent.x.sellingCommission',
      type: 'hidden',
      label: 'Selling Agent Commission %',
      entity: 'contacts',
      entityType: 'agent',
    },
  },
} satisfies CoverSheetConfigCard;
